import {
  ContentEditableInput,
  TextBase,
  TooltipBubble,
} from '@carboncopyco/ui';

export interface InfoPageEditableDescriptionProps {
  description?: string;
  onDescriptionChange: (description: string) => void;
  disabled: boolean;
}
export const InfoPageEditableDescription = ({
  description,
  onDescriptionChange,
  disabled,
}: InfoPageEditableDescriptionProps) => {
  return (
    <ContentEditableInput
      disabled={disabled}
      onChange={onDescriptionChange}
      bordered
      inputSize="sm"
    >
      <TooltipBubble
        placement="top-start"
        title={description}
        disabled={!description}
      >
        <div className="w-11/12 truncate">
          <TextBase
            label={description}
            ellipsis
            color="text-ds-natural-600"
          />
        </div>
      </TooltipBubble>
    </ContentEditableInput>
  );
};
